/** AI comms helpers — subject lines and email drafts. */
import { API_BASE } from "@/lib/utils";
import { getAuthHeaders } from "@/lib/auth-fetch";

export async function suggestEmailSubjects({ message, eventId } = {}) {
  const res = await fetch(`${API_BASE}/api/admin/ai/comms/subjects`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ message: message || "Save the date", event_id: eventId }),
  });
  if (!res.ok) throw new Error(`Subject suggestions failed (${res.status})`);
  const data = await res.json();
  return data.subjects || [];
}

export async function draftEmailBody({ message, eventId } = {}) {
  const res = await fetch(`${API_BASE}/api/admin/ai/comms/draft`, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ message: message || "Event invitation", event_id: eventId }),
  });
  if (!res.ok) throw new Error(`Draft generation failed (${res.status})`);
  const data = await res.json();
  return data.body || "";
}
